import React from 'react';
import { useAuth } from '../context/AuthContext';
import HRPanel from './HRPanel';
import EmployeeLeadsView from './EmployeeLeadsView';

function LeadsWrapper() {
  const { user, hasPermission } = useAuth();

  // Check if user is HR or Admin (can manage leads)
  const canManageLeads = user?.role?.name === 'HR' || user?.role?.name === 'Admin' || hasPermission('leads', 'create');

  return canManageLeads ? <HRPanel /> : <EmployeeLeadsView />;
}

export default LeadsWrapper;
